import React from 'react';
import PropTypes from 'prop-types';
import AlertDialog from 'components/common/dialogs/AlertDialog';

const AlertModal = props => {
	const {
		classNameHeader,
		onClose,
		title,
		// on mobile the dialog spans the viewport and stacks: the ok button is full-width
		// there, which cannot sit next to the message in a shrink-to-fit row
		className = 'fixed top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 text-2xl flex items-center px-8 py-12 bg-blue-500 max-md:w-screen max-md:flex-col max-md:items-stretch max-md:gap-4 max-md:px-4 max-md:text-xl',
		severity = 'success',
	} = props;

	let header;
	if (title || onClose) {
		header = <div className={classNameHeader}>{title}</div>;
	}
	return (
		<div>
			{header}
			<AlertDialog onOk={onClose} {...props} className={className} severity={severity} />
		</div>
	);
};

AlertModal.propTypes = {
	action: PropTypes.object,
	onClose: PropTypes.func.isRequired,
	severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),
	message: PropTypes.string.isRequired,
};

export default AlertModal;
